<template>
  <div class="set">
    <div class="set__wrapper">
      <img class="set__logo" src="../assets/images/logo.svg" alt="" />
      <div class="set__title">Создание пароля</div>
      <form class="set__form" @submit.prevent>
        <div class="set__form-body">
          <div class="set__form-block">
            <div class="set__form-title">Введите пароль</div>
            <Input
              :type="password.type"
              :name="password.name"
              :value="password.value"
              :status="password.status"
              @input="handleChange"
              @paste="handleChange"
              @change="handleChange"
            />
            <span class="set__form-error" v-if="password.error">{{
              password.error
            }}</span>
          </div>
          <div class="set__form-block">
            <div class="set__form-title">Подтвердите пароль</div>
            <Input
              :type="confirm.type"
              :name="confirm.name"
              :value="confirm.value"
              :status="confirm.status"
              @input="handleChange"
              @paste="handleChange"
              @change="handleChange"
            />
            <span class="set__form-error" v-if="confirm.error">{{
              confirm.error
            }}</span>
          </div>
        </div>
        <div class="set__form-footer">
          <Button
            :type="'text'"
            :value="'Отправить'"
            :paint="'blue'"
            :disabled="!validation"
            @click="handleFormSumbit"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from "vuex";
  import Button from "../components/Button";
  import Input from "../components/Input";

  export default {
    name: "Set",
    components: {
      Button,
      Input,
    },
    computed: {
      ...mapGetters({
        password: "getSetPassword",
        confirm: "getSetConfirm",
        validation: "getSetValidation",
      }),
    },
    methods: {
      ...mapMutations(["handleSetChanges"]),
      ...mapActions(["sendSetChanges", "logoutAuthorization"]),
      handleChange(event) {
        let payload = {
          page: "set",
          event: event.type,
          name: event.target.getAttribute("name"),
          value: event.target.value,
        };

        this.handleSetChanges(payload);
      },
      handleFormSumbit() {
        this.sendSetChanges();
      },
    },
    created() {
      this.logoutAuthorization();
    },
  };
</script>

<style lang="scss" scoped>
  .set {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;

    @include mediaquery(md) {
      min-height: calc(100vh - 20px);
    }

    &__wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;

      @include mediaquery(sm) {
        width: 400px;
      }
    }

    &__logo {
      width: 50px;
      margin-bottom: 24px;

      @include mediaquery(sm) {
        margin-bottom: 44px;
      }
    }

    &__title {
      width: 100%;
      margin-bottom: 20px;
      text-transform: uppercase;
      text-align: center;
      font-size: 24px;
    }

    &__form {
      @include base;

      width: 100%;
      padding: 20px;

      @include mediaquery(sm) {
        padding: 46px 40px 25px;
      }

      &-body {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      &-block {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 10px;
        position: relative;

        &:last-of-type {
          margin-bottom: 0;
        }
      }

      &-title {
        @include title;
      }

      &-error {
        position: absolute;
        top: 100%;
        font-size: 9px;
        color: #ff8068;
      }

      &-footer {
        display: flex;
        flex-direction: column;
        margin-top: 20px;

        @include mediaquery(sm) {
          flex-direction: row;
          justify-content: space-between;
        }

        button {
          width: 100%;
        }
      }
    }
  }
</style>